import React, { useState } from 'react';
import { AppBar, Toolbar, InputBase, IconButton, Grid, Typography, Button, Select, Menu, OutlinedInput, TextField, createMuiTheme, ThemeProvider, Paper } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import MicIcon from '@material-ui/icons/Mic';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import ExpandMore from '@material-ui/icons/ExpandMore';
import { Search } from '@mui/icons-material';
import Input from '../../Input/Input';
import { Autocomplete } from '@mui/material';
import { MenuOutlined } from '@material-ui/icons';
import { Alert, MenuItem } from '@mui/material';
import { LinearScale, AccessTimeOutlined, BlockOutlined, CalendarTodayOutlined } from '@material-ui/icons';


const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        marginTop: 15,
        marginLeft: 0
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    title: {
        flexGrow: 1,
        display: 'none',
        [theme.breakpoints.up('sm')]: {
            display: 'block',
        },
    },
    search: {
        position: 'relative',
        borderRadius: theme.shape.borderRadius,
        backgroundColor: theme.palette.common.white,
        '&:hover': {
            backgroundColor: theme.palette.common.white,
        },
        marginRight: theme.spacing(2),
        marginLeft: 0,
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            marginLeft: theme.spacing(3),
            width: 'auto',
        },
    },
    searchIcon: {
        padding: theme.spacing(0, 2),
        height: '100%',
        position: 'absolute',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    inputRoot: {
        color: 'inherit',
    },
    inputInput: {
        padding: theme.spacing(1, 1, 1, 0),
        paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('md')]: {
            width: '20ch',
        },
    },
    GridAtualization: {
        display: 'flex'
    },
    TextAtualizationOne: {
        fontSize: '12px',
        color: '#acadaf',
        fontFamily: 'montserrat'
    },
    TitleOne: {
        color: '#424651',
        fontSize: '15px',
        fontWeight: 'bold',
        fontFamily: 'montserrat'
    },
    rootTwo: {
        padding: '2px 4px',
        display: 'flex',
        alignItems: 'center',
        width: 400,
    },
    input: {
        marginLeft: theme.spacing(1),
        flex: 1,
    },
    iconButton: {
        padding: 10,
    },
    divider: {
        height: 28,
        margin: 4,
    },
    SelectEmployee: {
        width: '100%',
        height: '56px',
        borderRadius: 10,
        textAlign: 'center',
        fontSize: 10,
        fontWeight: 'bold',
        marginLeft: 5,
        border: '0px solid #dfe1e3'
    },
    // inputOutlined: {
    //     textAlign: 'left',
    //     width: 70
    // },
    // inputOutlinedStatus: {
    //     textAlign: 'left',
    //     width: 70
    // },
    roundedInput: {
        '& .MuiOutlinedInput-root': {
            borderRadius: 10,
            '& fieldset': {
                borderRadius: 10,
            },
        },
    },
}));

const useStylesBotton = makeStyles((theme) => ({
    root: {
        '& > *': {
            margin: theme.spacing(1),
        },
        display: 'flex',
    },
    activeButton: {
        backgroundColor: '#5aca5e', // Cor de fundo verde
        color: 'white', // Texto branco
        borderRadius: 20,
        width: '100%',
        '&:hover': {
            backgroundColor: '#388E3C', // Cor de fundo mais escura ao passar o mouse
        },
        textTransform: 'none',
        fontFamily: 'montserrat',
        fontSize: 10
    },
    buttonCell: {
        textTransform: 'none',
        fontFamily: 'montserrat',
        color: '#8b8b8b',
        fontSize: 10,
        whiteSpace: 'nowrap',
        display: 'flex',
        justifyContent: 'flex-start',
        width: '100%'
    },
    menuPaper: {
        borderRadius: 15,
        width: 300,
        // marginLeft: -100,
        marginLeft: (window.innerWidth * 0.1) * -1,
        marginTop: 25,
        position: 'fixed',
        display: 'flex', // Adicionado para habilitar o alinhamento flexível
        justifyContent: 'center', // Centraliza horizontalmente
        alignItems: 'center',
        '&::after': {
            content: '""',
            position: 'absolute',
            top: '50%', // Centraliza a seta verticalmente
            right: -20, // Move a seta para a direita do menu
            width: 0,
            height: 0,
            borderTop: '20px solid transparent', // Aumenta o tamanho da seta
            borderBottom: '20px solid transparent', // Aumenta o tamanho da seta
            borderLeft: `20px solid ${theme.palette.background.paper}`,
            transform: 'translateY(-50%)'
        },
        overflow: 'visible'
    }
}));

const theme = createMuiTheme({
    overrides: {
        MuiOutlinedInput: {
            root: {
                borderRadius: 10,
            },
        },
    },
});

const StyledExpandMore = withStyles({
    root: {
        color: '#cccacb',
        fontSize: 20,
        fontWeight: 'bold',
        marginRight: 5,
    },
})(ExpandMore);

const StyledSearchIcon = withStyles({
    root: {
        color: 'white',
        fontSize: 12
    },
})(Search);

export default function SearchAppBar({
    departmentList,
    employeeNewData,
    handlechangeFilter,
    selectedDepartment,
    schedule,
    scheduleSelected,
    status,
    selectedEmployee,
    handleSelectedEmployee,
    handleSelectedCard,
    tableState,
    handleOpenModalConfig
}) {
    const classes = useStyles();
    const classesBotton = useStylesBotton();

    function capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
    }

    const [openDepartment, setOpenDepartment] = useState(false)
    const [openSchudele, setOpenSchudele] = useState(false)
    const [openStatus, setOpenStatus] = useState(false)



    return (
        <div className={classes.root}>
            <Grid container direction="row" justifyContent="center" alignItems="center">
                <Grid item xs={12} sm={12}>
                    <Grid container justifyContent="center">
                        <Typography className={classes.TitleOne}> Listagem de colaboradores da sua empresa </Typography>
                    </Grid>
                </Grid>
                <Grid xs={12} sm={12} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginLeft: -10, marginTop: 15 }}>
                    <Typography style={{ color: '#acadaf', fontSize: 12, whiteSpace: 'nowrap', marginLeft: 10 }}>Filtrar por:</Typography>
                    <Autocomplete
                        options={employeeNewData.map((employee) => capitalizeFirstLetter(employee.name))}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={selectedEmployee ? "" : "Todos"}
                                variant="standard"
                                InputProps={{
                                    ...params.InputProps,
                                    style: {
                                        color: 'white',
                                        border: 'none',
                                        fontSize: 10,
                                        marginLeft: '10px',
                                        textAlign: 'center' // Centraliza horizontalmente
                                    },
                                    disableUnderline: true,
                                    endAdornment: (
                                        <>
                                            {params.InputProps.endAdornment} {/* Mantém o ícone de limpar */}
                                        </>
                                    ),
                                }}
                                InputLabelProps={{
                                    style: { color: 'white', fontSize: 10, marginLeft: 10 },
                                }}
                                style={{
                                    height: 50,
                                    display: 'flex',
                                    alignItems: 'center', // Centraliza verticalmente
                                    justifyContent: 'center' // Centraliza horizontalmente
                                }}
                                className={classes.roundedInput}
                                defaultValue={selectedEmployee}
                            />
                        )}
                        className={classes.SelectEmployee}
                        style={{ backgroundColor: '#484fdb', color: 'white', fontSize: 10 }}
                        PaperComponent={({ children }) => (
                            <Paper style={{ width: '300px', fontSize: 10 }}>{children}</Paper>
                        )}
                        value={selectedEmployee}
                        onChange={(event, newValue) => handleSelectedEmployee(newValue)}
                    />


                    <Select
                        value={selectedDepartment}
                        onChange={event => handlechangeFilter(event, 'department')}
                        open={openDepartment}
                        onClose={() => setOpenDepartment(false)}
                        input={
                            <OutlinedInput
                                classes={{ input: classes.inputOutlined }}
                                notched={false}
                                labelWidth={0}
                            />
                        }
                        IconComponent={() => (
                            <Button
                                onClick={() => setOpenDepartment(!openDepartment)}
                                style={stylesMenu.buttonExpand}
                                border= 'none'
                            >
                                <StyledExpandMore />
                            </Button>
                        )}
                        className={classes.SelectEmployee}
                        style={{ backgroundColor: 'white', color: '#4e525a' }}
                    >
                        <MenuItem value={'departamento'} style={{ color: '#484fdb' }}>Departamento</MenuItem>
                        {
                            departmentList.map((department, index) => (
                                <MenuItem value={department.name}>{capitalizeFirstLetter(department.name)}</MenuItem>
                            ))
                        }
                    </Select>

                    <Select
                         value={scheduleSelected}
                         onChange={event => handlechangeFilter(event, 'schedule')}
                         open={openSchudele}
                         onClose={() => setOpenSchudele(false)}
                         input={
                             <OutlinedInput
                                 classes={{ input: classes.inputOutlined }}
                                 notched={false}
                            labelWidth={0}
                             />
                         }
                          IconComponent={() => (
                               <Button
                                 onClick={() => setOpenSchudele(!openSchudele)}
                         style={stylesMenu.buttonExpand}
                        >
                             <StyledExpandMore />
                         </Button>
                          )}
                        className={classes.SelectEmployee}
                        style={{ backgroundColor: 'white', color: '#4e525a' }}
                        marginRight='30'
                    >
                        <MenuItem value={'escala'} style={{ color: '#484fdb' }}>Todas as escalas</MenuItem>
                        <MenuItem value={'notSchedule'} style={{ color: '#484fdb' }}>Sem Escala </MenuItem>
                        {
                            schedule.map((schedule, index) => (
                                <MenuItem value={schedule}>{capitalizeFirstLetter(schedule)}</MenuItem>
                            ))
                        }
                    </Select>

                    <Select
                        value={status}
                        onChange={event => handlechangeFilter(event, 'status')}
                        open={openStatus}
                        onClose={() => setOpenStatus(false)}
                        input={
                            <OutlinedInput
                                classes={{ input: classes.inputOutlinedStatus }}
                                notched={false}
                                labelWidth={0}
                            />
                        }
                        IconComponent={() => (
                            <Button
                                onClick={() => setOpenStatus(!openStatus)}
                                style={stylesMenu.buttonExpand}
                            >
                                <StyledExpandMore />
                            </Button>
                        )}
                        className={classes.SelectEmployee}
                        style={{ backgroundColor: 'white', color: '#4e525a' }}
                    >
                        <MenuItem value={'status'} style={{ color: '#484fdb' }}>Status</MenuItem>
                        <MenuItem  value={'ativos'}>Ativo</MenuItem>
                        <MenuItem value={'gestores'}>Gestor</MenuItem>
                        <MenuItem value={'pendentes'}>Pendentes</MenuItem>
                        <MenuItem value={'desligados'}>Desligados</MenuItem>
                    </Select>
                    <Grid item style={{ flex: 1, margin: 5 }}>
                        <Button
                            style={{
                                backgroundColor: '#cccacb',
                                height: 50,
                                borderRadius: 10,
                                width: '100%',
                            }}
                            variant='contained'
                            onClick={() => {
                                handleSelectedCard(null, 'search')
                            }}
                        >
                            <StyledSearchIcon />
                        </Button>
                    </Grid>
                    <Grid item style={{ flex: 1, margin: 5 }}>
                        <Button
                            style={{
                                backgroundColor: '#cccacb',
                                height: 50,
                                borderRadius: 10,
                                width: '100%',
                            }}
                            variant='contained'
                            onClick={event => {
                                tableState.openMenuCheckedEmployee(event)
                            }}
                        >
                            <MenuOutlined />
                        </Button>
                    </Grid>
                </Grid>

            </Grid>
            <div>
                <Menu
                    id="account-menu"
                    anchorEl={tableState.anchorElEmployeeList}
                    keepMounted
                    open={Boolean(tableState.anchorElEmployeeList)}
                    onClose={tableState.handleCloseMenuChecked}
                    anchorOrigin={{
                        vertical: 'center',
                        horizontal: 'center',
                    }}
                    transformOrigin={{
                        vertical: 'center',
                        horizontal: 'center',
                    }}
                    PaperProps={{
                        className: classesBotton.menuPaper,
                    }}
                >
                    <MenuItem style={stylesMenu.menuButton} onClick={() => handleOpenModalConfig('schedule')}>
                        <CalendarTodayOutlined style={stylesMenu.img} />
                        <a style={{ marginLeft: 15 }}>Escalas</a>
                    </MenuItem>
                    <MenuItem style={stylesMenu.menuButton} onClick={() => handleOpenModalConfig('bankOfHours')}>
                        <AccessTimeOutlined style={stylesMenu.img} />
                        <a style={{ marginLeft: 15 }}>Banco de horas</a>
                    </MenuItem>
                    <MenuItem style={stylesMenu.menuButton} onClick={() => handleOpenModalConfig('restrictions')}>
                        <BlockOutlined style={stylesMenu.img} />
                        <a style={{ marginLeft: 15 }}>Restrições</a>
                    </MenuItem>
                </Menu>
            </div>
        </div>
    );
}

const stylesMenu = {
    menuButton: {
        fontFamily: 'montserrat',
        fontSize: 12,
        fontWeight: 'bold',
        color: '#3d434c',
        marginLeft: 16
    },
    img: {
        width: '6%',
        height: 'auto',
    },
    divLine: {
        height: '2px',
        width: '20%',
        margin: '10px auto',
        borderBottom: '1px dashed gray',
        marginLeft: 60,
        fontWeight: 'bold'
    },
    buttonExpand: {
        width: 10
    }
}

